import {NewEntryFileWrapper, ProfileImageWrapper} from "widgets/profile/ui/styles.ts";
import Button from "@atomaro/ui-kit/components/Button/Button/Button";
import {CameraIcon} from "shared/ui/icons";
import {useEditProfile} from "widgets/profile/lib/useEditProfile.ts";
import {useUserStore} from "entities/user";
import userImg from 'assets/img/user.png'
import {useResize} from "../../../../app/lib/hooks/useResize.ts";



export const ProfileHeader = () => {
  const { onFileChange, fileInputRef } = useEditProfile({})
  const {isScreenMd} = useResize()
  const userInfo = useUserStore((s) => s.userInfo);
  
  const avatarId = userInfo?.profile?.avatar?.id
  const imgSrc = avatarId ? `/ecpp/attachments/files?attachmentId=${avatarId}` : userImg
  const imgAlt = avatarId ? `attachment_${avatarId}` : 'Profile icon'
  
  return (
    <ProfileImageWrapper>
      <img src={imgSrc} alt={imgAlt} height={isScreenMd ? 136 : 84} width={isScreenMd ? 136 : 84}/>
      <NewEntryFileWrapper>
        <Button
          label={"Изменить аватар"}
          style={{}}
          variant={"secondary"}
          size={"s"}
          iconPrefix={<CameraIcon/>}
          onClick={() => {}}
        />
        <input
          type="file"
          multiple={false}
          accept='.png,.jpg,.webp,.jpeg'
          ref={fileInputRef}
          onChange={onFileChange}
        />
      </NewEntryFileWrapper>
    </ProfileImageWrapper>
  )
}